export function validateContentType(contentType) {
    if( contentType === "image/png" || contentType === "image/jpeg" || contentType === "image/webp" || contentType === "video/mp4") {
        return contentType;
    }
    return null;
}

export function mapContentTypeToAllowedExtension(contentType) {
    switch (contentType) {
        case "image/png":
            return ".png";
        case "image/jpeg":
            return ".jpg";
        case "image/webp":
            return ".webp";
        case "video/mp4":
            return ".mp4";
        default:
            return null;
    }
}

export function mapExtensionToAllowedContentType(extension) {
    const formattedExtension = extension.startsWith(".") ? extension.toLowerCase() : `.${extension.toLowerCase()}`;
    switch (formattedExtension) {
        case ".png":
            return "image/png";
        case ".jpg":
        case ".jpeg":
            return "image/jpeg";
        case ".webp":
            return "image/webp";
        case ".mp4":
            return "video/mp4";
        default:
            return null;
    }
}
